import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { SupportGridview, SupportGridviewTableBodyCell, SupportGridviewTemplateCell } from 'app/support/_models/supportGridview';
import { SellerOnVacation } from '../../_models/sellerOnVacation';
import { SupportSellerVacationService } from '../../seller-vacation.service';
import { NotificationService } from 'app/_services/notification.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
    selector: 'app-seller-vacation-list', templateUrl: './seller-vacation-list.component.html', styleUrls: ['./seller-vacation-list.component.scss'],
    standalone: false
})
export class SupportSellerVacationListComponent {
    @ViewChild('isBillableTemplate') isBillableTemplate: TemplateRef<any>;
    @ViewChild('actionTemplate') actionTemplate: TemplateRef<any>;

    private _sellersOnVacation: SellerOnVacation[] = [];

    public config: SupportGridview = new SupportGridview();
    public templatesArray: SupportGridviewTemplateCell[] = [];

    constructor(private sellerVacationService: SupportSellerVacationService, private notificationService: NotificationService, private ngxLoader: NgxUiLoaderService) { }

    ngOnInit(): void {
        this.config.set({
            actions: {
                edit: { enable: false },
                action: { enable: false },
                remove: { enable: false },
                reject: { enable: true, confirmationText: 'support.seller-vacation.table.icon-button.confirm', tooltipText: 'support.seller-vacation.table.icon-button.tooltip' },
            },
            emptyText: { isHtml: false, value: 'support.seller-vacation.table.empty' },
            list: this.sellersOnVacation,
            table: {
                body: [
                    new SupportGridviewTableBodyCell('col-0-25 text-center', 'sellerId'),
                    new SupportGridviewTableBodyCell('col', 'holdingName', 'string', null, null, true),
                    new SupportGridviewTableBodyCell('col truncate-gridview', 'sellerOnVacation', 'string', null, null, true),
                    new SupportGridviewTableBodyCell('col', 'substituteSeller', 'string', null, null, true),
                    new SupportGridviewTableBodyCell('col-0-5 text-center', 'startDate', 'date'),
                    new SupportGridviewTableBodyCell('col-0-5 text-center', 'endDate', 'date')
                ],
                header: [
                    { className: 'col col-0-25 text-center', value: 'support.seller-vacation.table.title.id' },
                    { className: 'col', value: 'support.seller-vacation.table.title.holding' },
                    { className: 'col', value: 'support.seller-vacation.table.title.seller-name' },
                    { className: 'col', value: 'support.seller-vacation.table.title.seller-substitute' },
                    { className: 'col col-0-5 text-center', value: 'support.seller-vacation.table.title.start-date' },
                    { className: 'col col-0-5 text-center', value: 'support.seller-vacation.table.title.end-date' },
                    { className: 'col col-0-25 text-center', value: '' }
                ]
            },
            hasSmallActions: true,
        });
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.templatesArray = [
                { name: 'isBillableTemplate', template: this.isBillableTemplate },
                { name: 'actionTemplate', template: this.actionTemplate }
            ];
        })
    }

    deleteSellerOnVacation(sellerOnVacation: SellerOnVacation): void {
        this.ngxLoader.startLoader('loader-principal');

        this.sellerVacationService.endSellerVacation(sellerOnVacation.sellerId, sellerOnVacation.substituteSellerId).subscribe({
            next: () => {
                this.sellersOnVacation = this.sellersOnVacation.filter(s => s.sellerId !== sellerOnVacation.sellerId);
                this.notificationService.showSuccessToastr('support.seller-vacation.messages.success.delete-vacation', { translateMessage: true });

                this.ngxLoader.stopLoader('loader-principal');
            },
            error: () => {
                this.notificationService.showErrorToastr('support.seller-vacation.messages.error.delete-vacation', { translateMessage: true });
            }
        });
    }

    @Input() get sellersOnVacation(): SellerOnVacation[] { return this._sellersOnVacation; }

    set sellersOnVacation(value: SellerOnVacation[]) {
        this._sellersOnVacation = value;
        this.config.list = value;
    }
}
